import React, { useEffect } from "react";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { Button } from "@/components/common/Button";
import GlobalStyle from "@/components/common/GlobalStyle/GlobalStyle";
import { useIsExpired } from "@/states/user.state";
import useAccountNewShow from "@/hooks/user/account/useAccountNewShow";
import usePlanDetails from "@/hooks/common/usePlanDetails";
import { openChatPopup } from "@/helper/helper";
import { PlanComponentPropsType } from "@/types/all.types";
import { TfiClose } from "react-icons/tfi";
import { FaCheck } from "react-icons/fa6";
import style from "./UpgradePopupMobile.module.scss";
export const UpgradePopupMobile: React.FC<PlanComponentPropsType> = ({
  plan_uuid
}) => {
  const t = useTranslations("AlertsDashboard.UpgradePopup");
  const {
    setParams
  } = useIsExpired();
  const {
    accountNewData
  } = useAccountNewShow();
  const accountInfo = accountNewData?.data;
  const {
    data,
    mutatePlanDetails,
    isLoading
  } = usePlanDetails();
  const handleRequest = () => {
    if (!isLoading) mutatePlanDetails(plan_uuid!);
  };
  useEffect(() => {
    if (plan_uuid) handleRequest();
  }, []);
  function onExpired() {
    setParams({
      isExpired: false
    });
  }
  function onOpenPopup() {
    openChatPopup();
    onExpired();
  }
  const planName = accountInfo?.plan_name === "Free Trial" ? t.rich("trialMobile", {
    span: children => <span>{children}</span>
  }) : t.rich("planExpiredMobile", {
    span: children => <span>{children}</span>,
    planName: accountInfo?.plan_name
  });
  return !isLoading ? <div className={style.wrapper} id="upgrade-popup-mobile-wrapper" data-sentry-component="UpgradePopupMobile" data-sentry-source-file="UpgradePopupMobile.tsx">
            <GlobalStyle data-sentry-element="GlobalStyle" data-sentry-source-file="UpgradePopupMobile.tsx" />
            <div className={style.backdrop} onClick={onExpired}></div>
            <div className={style.box}>
                <button className={style.close_btn} onClick={onExpired}>
                    <TfiClose color={"#A1A1A1"} size={16} data-sentry-element="TfiClose" data-sentry-source-file="UpgradePopupMobile.tsx" />
                </button>
                <div className={style.header}>

                    <h3>{planName}</h3>
                    <p className={style.subtitle}>{t("upgradeMessageMobile")}</p>
                </div>
                <ul>
                    <li className={style.list_item}>
                        <FaCheck color="#399930" size={20} data-sentry-element="FaCheck" data-sentry-source-file="UpgradePopupMobile.tsx" />
                        <p className={style.title}>{t("reasonToUpgrade.line1")}</p>
                    </li>
                    <li className={style.list_item}>
                        <FaCheck color="#399930" size={20} data-sentry-element="FaCheck" data-sentry-source-file="UpgradePopupMobile.tsx" />
                        <p className={style.title}>{t("reasonToUpgrade.line2")}</p>

                    </li>
                    <li className={style.list_item}>
                        <FaCheck color="#399930" size={20} data-sentry-element="FaCheck" data-sentry-source-file="UpgradePopupMobile.tsx" />
                        <p className={style.title}>{t("reasonToUpgrade.line3")}</p>
                    </li>
                    <li className={style.list_item}>
                        <FaCheck color="#399930" size={20} data-sentry-element="FaCheck" data-sentry-source-file="UpgradePopupMobile.tsx" />
                        <p className={style.title}>{t("reasonToUpgrade.line4")}</p>
                    </li>
                    <li className={style.list_item}>
                        <FaCheck color="#399930" size={20} data-sentry-element="FaCheck" data-sentry-source-file="UpgradePopupMobile.tsx" />
                        <p className={style.title}>{t("reasonToUpgrade.line5")}</p>
                    </li>

                </ul>
                <div className={style.btn_box}>
                    {data?.data.payload.limit_popup_btn_key === "contact" ? <Button className={style.redirect_btn} variant="primary" title={t("contactUs")} onClick={onOpenPopup} id="upgrade-popup-mobile-contact-btn" /> : <Link href={"/dashboard/pricing"}>
                            <Button className={style.redirect_btn} variant="primary" title={t("upgradeMobile")} onClick={onExpired} id="upgrade-popup-mobile-upgrade-btn" />
                        </Link>}
                </div>
            </div>
        </div> : <></>;
};